import { initializeTabs } from '@shared/tabs';

const tabGroupOptions = {
  tabWrapperIdentifier: '.page-header-media__tabs',
  hiddenClass: 'hidden',
}

initializeTabs(tabGroupOptions);

// Media description truncation logic
const tabWithDescription = document.getElementById('video-tabpanel-0');
const showMoreText = document.querySelector('.page-header-media__tabs')?.getAttribute('data-showmore');

if (tabWithDescription) {
  const text = tabWithDescription.innerText;

  if (text.length > 280) {
    const originalText = text;
    const firstPart = text.slice(0, 280) + '...';
    const pFirst = document.createElement('p');

    pFirst.innerText = firstPart;
    tabWithDescription.innerHTML = '';
    tabWithDescription.appendChild(pFirst);


    const showButton = document.createElement('button');
    showButton.classList.add('page-header-media__show-more-button');
    showButton.innerText = showMoreText || 'Visa mer';
    showButton.addEventListener('click', () => {
      tabWithDescription.innerText = originalText;
      showButton.remove();
    });

    tabWithDescription.appendChild(showButton);
  }
}
